import React from "react";
import { Redirect, Route } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import { DefaultLayout, HeaderNavigation, IconSidebar } from "./layouts";

// Route Views
import Analytics from "./views/Analytics";
import DetectionEvents from "./views/DetectionEvents";
import OnlineStore from "./views/OnlineStore";
import DetectionAnalysis from "./views/DetectionAnalysis";
import DetectionAnalysisIos from "./views/DetectionAnalysisIos";
import DeviceDetails from "./views/DeviceDetails";
import BlogOverview from "./views/BlogOverview";
import Logout from "./views/Logout";
import UserProfile from "./views/UserProfile";
import Login from "./views/Login";
import Register from "./views/Register";
import ForgotPassword from "./views/ForgotPassword";
import ChangePassword from "./views/ChangePassword";

// Layouts
const BlankIconSidebarLayout = ({ children }) => (
  <IconSidebar noNavbar noFooter>{children}</IconSidebar>
);

const NoNavBarSidebarLayout = ({ children }) => <div>{children}</div>;

export default [
  {
    path: "/",
    exact: true,
    layout: DefaultLayout,
    component: () => <Redirect to="/login" />, // Default redirect to login
  },
 
  {
    path: "/login",
    layout: NoNavBarSidebarLayout,
    component: Login,
  },
  {
    path: "/register",
    layout: NoNavBarSidebarLayout,
    component: Register,
  },
  {
    path: "/forgot-password",
    layout: NoNavBarSidebarLayout,
    component: ForgotPassword,
  },
  {
    path: "/change-password",
    layout: NoNavBarSidebarLayout,
    component: ChangePassword,
  },
  {
    path: "/logout",
    layout: NoNavBarSidebarLayout,
    component: Logout,
  },
  {
    path: "/user-profile",
    layout: DefaultLayout,
    component: UserProfile,protected: true,
  },
  // Protected Routes
  {
    path: "/analytics",
    layout: DefaultLayout,
    component: Analytics,
    protected: true,
  },
  {
    path: "/devicedetails",
    layout: DefaultLayout,
    component: DeviceDetails,
    protected: true,
  },
  {
    path: "/detection_events",
    layout: DefaultLayout,
    component: DetectionEvents,
    protected: true,
  },
  {
    path: "/ecommerce",
    layout: DefaultLayout,
    component: OnlineStore,
    protected: true,
  },
  {
    path: "/detection_overview_android",
    layout: DefaultLayout,
    component: DetectionAnalysis,
    protected: true,
  },
  {
    path: "/detection_overview_ios",
    layout: DefaultLayout,
    component: DetectionAnalysisIos,
    protected: true,
  },
];
